import { useUserDetailsStore } from '@marriott/mi-store-utils';
import { ReactNode } from 'react';
import { useNavContext } from '../../../organisms/NavigationContainer';
import { DEFAULT_TRACKING_VALUES } from '../../../utils/constants';
import { getClickTrackValue } from '../../../utils/TrackingPropertyUtils';
import { RestPropType } from '../NavigationUtilityLink';

export type MyTripsProps = {
  children: ReactNode;
  restProps: RestPropType;
  trackingContentPosition: string | undefined;
};

export const MyTrips = (props: MyTripsProps) => {
  const { children, restProps, trackingContentPosition } = props;
  const { setIsMyTripsModalOpen } = useNavContext();
  const userProfileData = useUserDetailsStore(state => state.userProfileData);
  const isSignedInUser = useUserDetailsStore(state => state.isSignedInUser);
  const myTripsCount = userProfileData?.trips?.upcomingReservationsCount || 0;

  const handleMyTripsClick = () => {
    setIsMyTripsModalOpen(true);
  };

  const panelTitle = restProps['cq:panelTitle'] || restProps?.resourceProperties['cq:panelTitle'];
  const propsObj = {
    className: 'utility-mytrips-button t-label-inverse-xs custom_click_track',
    'data-custom_click_track_value': getClickTrackValue({
      trackingProperties: {
        trackingContentPosition,
      },
      url: restProps['cq:panelUrl'],
      fallbacks: {
        description: restProps['cq:panelTitle'],
        position: DEFAULT_TRACKING_VALUES.GLOBAL_NAV,
      },
    }),
    'aria-label': `${panelTitle}${myTripsCount > 0 ? ` (${myTripsCount})` : ''}`,
  };

  return isSignedInUser ? (
    <a {...propsObj} href={userProfileData?.trips?.url}>
      {children}
      {myTripsCount > 0 && (
        <span aria-hidden="true" className="utility-link-text d-none d-xl-inline-block">
          ({myTripsCount})
        </span>
      )}
    </a>
  ) : (
    <button {...propsObj} onClick={handleMyTripsClick}>
      {children}
    </button>
  );
};
